@if (active && modules != null) {
  <div class="container-side-bar">
    <div class="container-icons">
      <div class="button-fixed" (click)="handlerSideBar()">
        @if (showSideBarExtended) {
          <mat-icon>skip_previous</mat-icon>
        }
        @if (!showSideBarExtended) {
          <mat-icon>skip_next</mat-icon>
        }
      </div>
      <mat-accordion>
        @for (module of modules; track module) {
          <mat-expansion-panel
            (opened)="selectModule(module.id, true)"
            (closed)="selectModule(module.id, false)"
            class="contend"
            hideToggle
            [expanded]="configAccordion.expanded[module.id]"
            (click)="module.id == 0 ? goToHome() : ''"
            >
            <mat-expansion-panel-header
              [style]="configAccordion.colorPanelSelected[module.id]"
              [matTooltip]="module.name"
              matTooltipPosition="right"
              matTooltipClass="tooltip-red"
              [matTooltipDisabled]="showSideBarExtended"
              >
              <div
                class="icon-menu"
            [style]="
              showSideBarExtended
                ? 'justify-content: space-between;'
                : 'justify-content: center;'
            "
                >
                <i class="fa iconFa" [ngClass]="module.icon" [style.color]="module.color"></i>
                @if (showSideBarExtended) {
                  <div>
                    <h2 class="m-0 menu-text">{{ module.name }}</h2>
                  </div>
                }
              </div>
            </mat-expansion-panel-header>
            @for (subModule of module.subModules; track subModule) {
              <div
                [matTooltip]="subModule.name"
                matTooltipPosition="right"
                matTooltipClass="tooltip-red"
                [matTooltipDisabled]="showSideBarExtended"
                >
                <div
                  class="icon-sub-menu"
                  (click)="selectSubModule(subModule)"
                  [id]="subModule.id"
                  [style.justify-content]="showSideBarExtended ? 'space-between' : 'center'"
                  [style.padding]="showSideBarExtended ? '4px' : '8px'"
                  [style]="configAccordion.colorSubMenuSelectd[subModule.id]"
                  >
                  <i class="fa iconFa" [ngClass]="subModule.icon" [style.color]="subModule.color"></i>
                  @if (showSideBarExtended) {
                    <div>
                      <h4 class="m-0">{{ subModule.name }}</h4>
                    </div>
                  }
                </div>
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
    <footer class="footer" [style.visibility]="showLogoExtended?'visible':'hidden'">
      <img
        [src]="
          showSideBarExtended
            ? '../assets/images/brainloper-logo2.0.png'
            : '../assets/images/brainloper-logo2.0-sm.png'
        "
        [style]="showSideBarExtended ? 'height: 13vh' : 'height: 4vh'"
        alt=""
        />
    </footer>
  </div>
}
